import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { DeleteAction, EditAction, VisibilityAction } from '../../../components/row-actions';

interface ItemRowProps {
    dragHandle: React.ReactNode;
    leading?: React.ReactNode;
    title: string;
    subtitle?: string;
    chips?: React.ReactNode;
    dimmed?: boolean;
    isVisible?: boolean;
    onToggleVisibility?: () => void;
    onEdit: () => void;
    onDelete: () => void;
}

export function ItemRow({ dragHandle, leading, title, subtitle, chips, dimmed, isVisible, onToggleVisibility, onEdit, onDelete }: ItemRowProps) {
    return (
        <Paper variant="outlined" sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 0.75, pr: 0.5 }}>
            {dragHandle}
            {leading}
            <Box sx={{ flex: 1, minWidth: 0, opacity: dimmed ? 0.6 : 1 }}>
                <Typography variant="body2" fontWeight={500} noWrap>{title}</Typography>
                {subtitle && <Typography variant="caption" color="text.secondary" noWrap component="div">{subtitle}</Typography>}
            </Box>
            {chips}
            {onToggleVisibility && <VisibilityAction isVisible={!!isVisible} onClick={onToggleVisibility} />}
            <EditAction onClick={onEdit} />
            <DeleteAction onClick={onDelete} />
        </Paper>
    );
}
